import axios from "axios";

const postsEndPoint = `${BJZM_DATA.site_url}/wp-json/wp/v2/posts`;
// const floorPlansEndPoint = `${BJZM_DATA.site_url}/wp-json/wp/v2/floor_plan/?&per_page=100`;
const floorPlanEndPoint = `${BJZM_DATA.site_url}/wp-json/wp/v2/floor_plan/?include[]=9273`;

class AppWebApiUtilities {

    constructor( args ) {
        this.args = args;
        this.getFloorPlans();
        this.getFloorPlan();
    }

    api(endPoint, params = null) {
        return new Promise((resolve, reject) => {
            axios.get(endPoint, {params: params}).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            }); 
        });
    }

    getPosts(params) {

        this.api(postsEndPoint, params).then((response)=>{
            const posts = response;
            this.args.callBack(posts);
        });
        return true;
    }

    getFloorPlans(params) {
        var floorPlansEndPoint = BJZM_DATA.site_url;
        floorPlansEndPoint += BJZM_DATA.current_language == 'fr' ? `/fr/wp-json/wp/v2/floor_plan/?&per_page=100` : `/wp-json/wp/v2/floor_plan/?&per_page=100`;
        this.api(floorPlansEndPoint, params).then((response)=>{
            const posts = response;
            this.args.callBack(posts);
        });
        return true;
    }
    getFloorPlan(params) {

        this.api(floorPlanEndPoint, params).then((response)=>{
            const posts = response;
            // console.log('single response', response);
            // this.args.callBack(posts);
        });
        return true;
    }

}

module.exports = AppWebApiUtilities;










